<template>
  <div class="card" id="threeDEnvironment">
    <nav class="fixed-bar navbar navbar-expand-lg navbar-light" color="white">
      <h3 class="navbar-brand">3D/2.5D Environment</h3>
      <add-environment
        @save="saveSetDesign"
        @open="openDialog"
        @close="closeDialog"
        v-bind:dialog="dialog"
        v-bind:info="editedItem"
        v-bind:edited-i-d="editedID">
      </add-environment>
    </nav>

    <hr/>
    <div class="container fluid grid-list-lg">
      <asset-table
        v-bind:updated="updated"
        v-bind:asset_type="asset_type"
        @edit="editItem"
        v-bind:headers="headers"
        >
      </asset-table>
    </div>
  </div>
</template>

<script>
import {db, assetMediaStorageRef, assetModelStorageRef} from '../../firebaseDB'
import addEnvironment from './add-new/addEnvironment3D'
import AssetTable from './assetTable'

export default {
  name: 'set-design',
  components: {AssetTable, addEnvironment},
  data: () => ({
    asset_type: 'set_design',
    headers: [
      {th: 'Name', name: 'name'},
      {th: 'Date Uploaded', name: 'date_uploaded'},
      // {th: 'Date Modified', name: 'date_modified'},
      {th: 'Uploaded By', name: 'creator'},
      // {th: 'Description', name: 'description'},
      // {th: 'Service', name: 'service'},
      {th: 'Media',
        name: 'media',
        render (row, cell, index) {
          if (row.hasOwnProperty('image')) {
            return `<a href="${row.image.imageURL}" target="_blank">
                  <img src="${row.image.imageURL}" style="width: 50px; height: 50px">
                </a>`
          } else if (row.hasOwnProperty('audio')) {
            return `<button type="button" class="btn btn-default"></button>`
          } else {
            return ''
          }
        }
      }
    ],
    fileType: {
      image: 'image',
      fbx: 'fbx',
      asset_bundle: 'asset_bundle'
    },
    osType: {
      iOS: 'iOS',
      Android: 'Android'
    },
    dialog: '',
    updated: false,
    editedItem: {
      id: null,
      name: '',
      typeOfDimension: '3D',
      numOfAssets: 0,
      selected_sounds: [],
      selected_assets: [],
      allow_effect: false,
      dimension: {
        X: 0,
        Y: 0,
        Z: 0
      },
      polygon_count: 1,
      fbx: {
        fileName: '',
        file: '',
        fileURL: ''
      },
      asset_bundle: {
        iOS: {
          fileName: '',
          file: '',
          fileURL: ''
        },
        Android: {
          fileName: '',
          file: '',
          fileURL: ''
        }
      },
      materials: '',
      interactive_surfaces: '',
      rotationOfOrigin: {
        X: 0,
        Y: 0,
        Z: 0
      },
      positionOfOrigin: {
        X: 0,
        Y: 0,
        Z: 0
      },
      scaleOfOrigin: {
        X: 0,
        Y: 0,
        Z: 0
      },
      polygonLimitation: '',
      description: ''
    },
    defaultItem: {
      id: null,
      name: '',
      typeOfDimension: '3D',
      numOfAssets: 0,
      selected_sounds: [],
      selected_assets: [],
      allow_effect: false,
      dimension: {
        X: 0,
        Y: 0,
        Z: 0
      },
      polygon_count: 1,
      fbx: {
        fileName: '',
        file: '',
        fileURL: ''
      },
      asset_bundle: {
        iOS: {
          fileName: '',
          file: '',
          fileURL: ''
        },
        Android: {
          fileName: '',
          file: '',
          fileURL: ''
        }
      },
      materials: '',
      interactive_surfaces: '',
      rotationOfOrigin: {
        X: 0,
        Y: 0,
        Z: 0
      },
      positionOfOrigin: {
        X: 0,
        Y: 0,
        Z: 0
      },
      scaleOfOrigin: {
        X: 0,
        Y: 0,
        Z: 0
      },
      polygonLimitation: '',
      description: ''
    },
    editedID: -1,
    editedIndex: -1
  }),
  methods: {
    saveSetDesign (updatedData) {
      const currentdate = new Date()
      const datetime = currentdate.getDate() + '/' +
        (currentdate.getMonth() + 1) + '/' +
        currentdate.getFullYear() + ' @ ' +
        currentdate.getHours() + ':' +
        currentdate.getMinutes() + ':' +
        currentdate.getSeconds()
      setTimeout(() => {
        let updates = {}
        let requireDefaultUpdate = true
        if (!updatedData.id) {
          updatedData.id = db.ref(`asset_data/${this.asset_type}/`).push().key
          updates[`asset_data/${this.asset_type}/${updatedData.id}/meta_data/creator`] = this.$store.state.user.email
          updates[`asset_data/${this.asset_type}/${updatedData.id}/meta_data/date_uploaded`] = datetime
        }
        updates[`asset_data/meta_data/${updatedData.id}/date_modified`] = datetime

        updates[`asset_data/${this.asset_type}/${updatedData.id}/name`] = updatedData.name || ''
        updates[`asset_data/${this.asset_type}/${updatedData.id}/typeOfDimension`] = updatedData.typeOfDimension || '3D'
        updates[`asset_data/${this.asset_type}/${updatedData.id}/numOfAssets`] = updatedData.numOfAssets
        updates[`asset_data/${this.asset_type}/${updatedData.id}/selected_sounds`] = updatedData.selected_sounds
        updates[`asset_data/${this.asset_type}/${updatedData.id}/selected_assets`] = updatedData.selected_assets
        updates[`asset_data/${this.asset_type}/${updatedData.id}/numOfAssets`] = updatedData.selected_assets.length
        updates[`asset_data/${this.asset_type}/${updatedData.id}/allow_effect`] = updatedData.allow_effect
        updates[`asset_data/${this.asset_type}/${updatedData.id}/materials`] = updatedData.materials
        updates[`asset_data/${this.asset_type}/${updatedData.id}/interactive_surfaces`] = updatedData.interactive_surfaces
        updates[`asset_data/${this.asset_type}/${updatedData.id}/dimension`] = {
          X: updatedData.dimension.X || '0',
          Y: updatedData.dimension.Y || '0',
          Z: updatedData.dimension.Z || '0'
        }
        updates[`asset_data/${this.asset_type}/${updatedData.id}/rotationOfOrigin`] = {
          X: updatedData.rotationOfOrigin.X || '0',
          Y: updatedData.rotationOfOrigin.Y || '0',
          Z: updatedData.rotationOfOrigin.Z || '0'
        }
        updates[`asset_data/${this.asset_type}/${updatedData.id}/positionOfOrigin`] = {
          X: updatedData.positionOfOrigin.X || '0',
          Y: updatedData.positionOfOrigin.Y || '0',
          Z: updatedData.positionOfOrigin.Z || '0'
        }
        updates[`asset_data/${this.asset_type}/${updatedData.id}/scaleOfOrigin`] = {
          X: updatedData.scaleOfOrigin.X || '0',
          Y: updatedData.scaleOfOrigin.Y || '0',
          Z: updatedData.scaleOfOrigin.Z || '0'
        }
        updates[`asset_data/${this.asset_type}/${updatedData.id}/polygon_count`] = updatedData.polygon_count
        updates[`asset_data/${this.asset_type}/${updatedData.id}/polygonLimitation`] = updatedData.polygonLimitation
        updates[`asset_data/${this.asset_type}/${updatedData.id}/description`] = updatedData.description
        updates[`asset_data/${this.asset_type}/${updatedData.id}/meta_data/date_modified`] = datetime

        if (this.shouldUpload(this.fileType.image, updatedData)) {
          this.uploadImage(updatedData, updates)
          requireDefaultUpdate = false
        }
        if (this.shouldUpload(this.fileType.fbx, updatedData)) {
          this.uploadFBX(updatedData, updates)
          requireDefaultUpdate = false
        }
        if (this.shouldUpload(this.fileType.asset_bundle, updatedData)) {
          this.uploadAssetBundle(updatedData, updates, this.osType.iOS)
          this.uploadAssetBundle(updatedData, updates, this.osType.Android)
          requireDefaultUpdate = false
        }
        if (requireDefaultUpdate) {
          db.ref('assets').update(updates).then(snapshot => {
            this.closeDialog()
            this.updated = true
          })
        }
      }, 500)
      this.updated = false
    },
    shouldUpload (fileType, updatedData) {
      if (fileType === this.fileType.image) {
        return updatedData.image && updatedData.image.imageFile
      } else if (fileType === this.fileType.fbx) {
        return updatedData.fbx && updatedData.fbx.file
      } else if (fileType === this.fileType.asset_bundle) {
        return (updatedData.asset_bundle.iOS && updatedData.asset_bundle.iOS.file) ||
          (updatedData.asset_bundle.Android && updatedData.asset_bundle.Android.file)
      } else {
        return false
      }
    },
    uploadImage (updatedData, updates) {
      assetMediaStorageRef.child(`${updatedData.id}.jpg`)
        .put(updatedData.image.imageFile)
        .then(snapshot => snapshot.ref.getDownloadURL())
        .catch(function (error) {
          console.log(`Error - ${error.message}`)
        })
        .then((url) => {
          updatedData.image.imageURL = url
        })
        .catch(function (error) {
          console.log(`Error - ${error.message}`)
        })
        .then(snapshot => {
          updates[`asset_data/${this.asset_type}/${updatedData.id}/image`] = updatedData.image || {imageURL: '', imageFile: ''}
          console.log('Your image file is saved in storage')
          db.ref('assets').update(updates)
            .then(snapshot => {
              this.closeDialog()
              this.updated = true
              console.log('Your image fileURL is saved in assets')
            })
        })
        .catch(function (error) {
          console.log('Error - ' + error.message)
        })
    },
    uploadFBX (updatedData, updates) {
      assetModelStorageRef.child(`${updatedData.id}/original.fbx`)
        .put(updatedData.fbx.file)
        .then(snapshot => snapshot.ref.getDownloadURL())
        .catch(function (error) {
          console.log(`Error - ${error.message}`)
        })
        .then((url) => {
          updatedData.fbx.fileURL = url
          console.log('Transferring file url')
        })
        .then(snapshot => {
          updates[`asset_data/${this.asset_type}/${updatedData.id}/fbx`] = updatedData.fbx || {
            fileURL: '',
            file: ''
          }
          console.log('Your fbx file is saved in storage')
          db.ref('assets').update(updates)
            .then(snapshot => {
              this.closeDialog()
              this.updated = true
              console.log('Your fbx fileURL is saved in assets')
            })
        })
    },
    uploadAssetBundle (updatedData, updates, osType) {
      if (updatedData.asset_bundle[osType] && updatedData.asset_bundle[osType].file) {
        assetModelStorageRef.child(`${updatedData.id}/${osType}`)
          .put(updatedData.asset_bundle[osType].file)
          .then(snapshot => snapshot.ref.getDownloadURL())
          .catch(function (error) {
            console.log(`Error - ${error.message}`)
          })
          .then((url) => {
            updatedData.asset_bundle[osType].fileURL = url
            console.log('Transferring asset bundle url')
          })
          .then(snapshot => {
            let key = `asset_data/${this.asset_type}/${updatedData.id}/asset_bundle/${osType}`
            updates[key] = updatedData.asset_bundle[osType] || {
              fileURL: '',
              file: ''
            }
            console.log(`Your ${osType} asset bundle is saved in storage`)
            db.ref('assets').update(updates)
              .then(snapshot => {
                this.closeDialog()
                this.updated = true
                console.log(`Your ${osType} asset bundle fileURL is saved in assets`)
              })
          })
      }
    },
    openDialog () {
      this.dialog = true
    },
    closeDialog () {
      this.editedID = -1
      this.editedIndex = -1
      this.editedItem = Object.assign({}, this.defaultItem)
      this.dialog = false
    },
    editItem (item) {
      this.editedIndex = item.index
      this.editedID = item.id
      this.editedItem = Object.assign(this.getEditedItem(item.item), item.item)
      if (!this.editedItem.hasOwnProperty('positionOfOrigin')) {
        this.editedItem.positionOfOrigin = {
          X: 0,
          Y: 0,
          Z: 0
        }
      }
      if (!this.editedItem.hasOwnProperty('rotationOfOrigin')) {
        this.editedItem.rotationOfOrigin = {
          X: 0,
          Y: 0,
          Z: 0
        }
      }
      if (!this.editedItem.hasOwnProperty('scaleOfOrigin')) {
        this.editedItem.scaleOfOrigin = {
          X: 0,
          Y: 0,
          Z: 0
        }
      }
      this.dialog = true
    },
    getEditedItem (item) {
      let additional1 = []
      let additional2 = []
      let additional3 = []
      let additional4 = []
      db.ref(`assets/asset_data/set_design/${item.id}/existing_set_lighting`)
        .once('value')
        .then((snapshot) => {
          if (snapshot.val()) {
            Object.keys(snapshot.val()).forEach(function (k) {
              additional1.push(snapshot.val()[k])
            })
          }
        })
        .catch(function (error) {
          console.log('Error - ' + error.message)
        })
      db.ref(`assets/asset_data/set_design/${item.id}/existing_props`)
        .once('value')
        .then((snapshot) => {
          if (snapshot.val()) {
            Object.keys(snapshot.val()).forEach(function (k) {
              additional2.push(snapshot.val()[k])
            })
          }
        })
        .catch(function (error) {
          console.log('Error - ' + error.message)
        })
      db.ref(`assets/asset_data/set_design/${item.id}/allowed_set_lighting`)
        .once('value')
        .then((snapshot) => {
          if (snapshot.val()) {
            Object.keys(snapshot.val()).forEach(function (k) {
              additional3.push(snapshot.val()[k])
            })
          }
        })
        .catch(function (error) {
          console.log('Error - ' + error.message)
        })
      db.ref(`assets/asset_data/set_design/${item.id}/allowed_props`)
        .once('value')
        .then((snapshot) => {
          if (snapshot.val()) {
            Object.keys(snapshot.val()).forEach(function (k) {
              additional4.push(snapshot.val()[k])
            })
          }
        })
        .catch(function (error) {
          console.log('Error - ' + error.message)
        })
      return {
        default_lighting: additional1,
        default_props: additional2,
        allowed_lighting: additional3,
        allowed_props: additional4
      }
    }
  }
}
</script>

<style scoped>
#threeDEnvironment{
  scroll-margin: 150px;
}

</style>



// WEBPACK FOOTER //
// src/components/assets/environment3D.vue